import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';
import type DocumentTypeView from '@UI/Store/DocumentTypes/Views/DocumentTypeView';

type DocumentTypeFormArgs = {
	label: string;
};

/**
 * Shared by both the "create" and "rename" modes of `DocumentTypeSidebar`: a document type only ever
 * carries a label through this form — the key is derived server-side and never sent.
 */
@ValidatedClass()
class DocumentTypeFormData extends AbstractValidatedClass<DocumentTypeFormArgs> {
	@constraint(Joi.string().trim().max(180), () => 'Le libellé ne peut pas dépasser 180 caractères.')
	@constraint(Joi.string().trim().required(), () => 'Le libellé est obligatoire.')
	public readonly label: string;

	constructor(data: DocumentTypeFormArgs) {
		super(data);
		this.label = data.label;
		Object.freeze(this);
	}

	static createEmpty(): DocumentTypeFormData {
		return new DocumentTypeFormData({ label: '' });
	}

	static fromView(documentType: DocumentTypeView): DocumentTypeFormData {
		return new DocumentTypeFormData({ label: documentType.label });
	}

	setLabel(label: string): this {
		return this.cloneWith({ label } as Partial<DocumentTypeFormArgs>);
	}
}

export default DocumentTypeFormData;
